import {
  type HomepageEntryExperimentAttribution,
  type HomepageEntryVariant,
  parsePostHogDistinctId,
} from "@teksta/shared-types";

export type { HomepageEntryVariant } from "@teksta/shared-types";
export { parseHomepageEntryVariant } from "@teksta/shared-types";

export const HOMEPAGE_ENTRY_VARIANT_PARAM = "homepageEntryVariant";

const validationOrigin = "https://teksta.invalid";

export const buildHomepageExperimentSignUpMetadata = ({
  distinctId,
  variant,
}: {
  distinctId: unknown;
  variant: HomepageEntryVariant | undefined;
}): Partial<HomepageEntryExperimentAttribution> => {
  const posthogAnonymousId = parsePostHogDistinctId(distinctId);
  if (!variant || !posthogAnonymousId) return {};

  return { homepageEntryVariant: variant, posthogAnonymousId };
};

export const withHomepageEntryVariant = (
  href: string,
  variant: HomepageEntryVariant | undefined
): string => {
  if (!variant) return href;

  const url = new URL(href, validationOrigin);
  if (url.origin !== validationOrigin) return href;
  url.searchParams.set(HOMEPAGE_ENTRY_VARIANT_PARAM, variant);
  return `${url.pathname}${url.search}${url.hash}`;
};
